import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import { getPublicActualites } from '../services/actualiteService';
import { dateLocaleOf, usePublicLocale, usePublicPaths } from '../routes/publicPaths';
import { normalizeStorageUrl } from '../config/apiBase';
import './PublicSimplePages.css';

const ActualitesPage = () => {
  const { t } = useTranslation();
  const locale = usePublicLocale();
  const paths = usePublicPaths();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublicActualites({ limit: 24 })
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="public-simple-page">
      <Helmet>
        <title>{`${t('public.news.metaTitle')} | ${t('public.brand.titleSuffix')}`}</title>
      </Helmet>
      <Navbar />
      <main className="public-simple-page__main" style={{ width: 'min(1100px, calc(100% - 2rem))' }}>
        <h1>{t('public.news.title')}</h1>
        {loading ? (
          <p className="public-simple-page__muted">{t('common.loading')}</p>
        ) : items.length === 0 ? (
          <p className="public-simple-page__muted">{t('public.home.noNews')}</p>
        ) : (
          <div className="public-news-grid">
            {items.map((item) => (
              <Link key={item.id} to={paths.actualite(item.id)} className="public-news-card">
                {item.image_url ? (
                  <img src={normalizeStorageUrl(item.image_url)} alt="" />
                ) : (
                  <div className="public-news-card__ph" />
                )}
                <div className="public-news-card__body">
                  <p className="public-news-meta">
                    {item.date ? new Date(item.date).toLocaleDateString(dateLocaleOf(locale)) : ''}
                    {item.categorie ? ` · ${item.categorie}` : ''}
                  </p>
                  <h2>{item.titre}</h2>
                  <p className="public-simple-page__muted" style={{ margin: 0 }}>
                    {(item.description || '').slice(0, 120)}
                    {(item.description || '').length > 120 ? '…' : ''}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default ActualitesPage;
